export default {"src":"/_next/static/media/steeringWheel_24.66e95782.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};